import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const BioUniDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}>Cazan termic, model universal <span className={styles.highlight}>Bio Uni</span></p>
      <p className={styles.text}>
        Cazan termic universal BIO UNI recomandat pentru încălzirea spațiilor industriale , depozitare și alte clădiri de mari dimensiuni, care sunt deja echipate cu un sistem de încălzire centralizat pentru furnizarea de căldură în nevoile tehnologice, folosind antracit, cărbune, lemn de foc și altele ca combustibil.
      </p>
      <p className={styles.text}>
        Proiectarea cazanului permite utilizarea cea mai eficienta a căldurii generate în timpul arderii diferitelor tipuri de combustibili solizi cu puține calorii, iar randamentul maxim de căldurii al cazanului este obținut prin arderea antracitului.
      </p>
      <p className={styles.text}>
        Cazanele Bio Uni sunt folosite în module mobile și fixe pentru sistemele închise de alimentare cu căldură.
      </p>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-circle-plus fa-2x" />
          <p>Exista posibilitatea instalării suplimentare a buncărului și a șnecului de alimentare automată a combustibilului.
            Cu aceasta configurare, cazanul va funcționa autonom cu tocătura lemnoasa, turba, rumeguș, peleți de toate tipurile, cat și pe cărbune fracționat.</p>
        </div>
      </div>
      <h1 className={styles.title}>Caracteristicile  cazanului</h1>
      <p className={styles.text}>
        Pentru protejarea pierderii de căldură a cazanului prin pereții exteriori, am îmbrăcat cazanul cu un strat de izolație termica plasat sub carcasa decorativă a acestuia.
      </p>
      <p className={styles.text}>
        Ușile cazanului sunt reglabile și au un șnur termoizolant ce etanșează ușița de gura cazanului, astfel garantând izolația ermetică perfectă a camerei de ardere.
      </p>
      <p className={styles.text}>
        Combustibilul este așezat pe grilajul de fonta din camera de ardere. După aprinderea acestuia are loc arderea cu ajutorul injecției de aer adus cu ajutorul ventilatoarelor atașate cazanului. Reglarea funcționării ventilatoarelor se face cu ajutorul blocului de comanda.
      </p>
      <p className={styles.text}>
        Aerul este suflat prin duzele situate deasupra grilajului 30 % și sub acesta 70 % ,pentru arderea completa a gazelor rezultate în urma arderii combustibilului.
      </p>
      <p className={styles.text}>
        Partea convexă este formată din doua rânduri cu tuburi de foc.
      </p>
      <p className={styles.text}>
        Pentru îmbunătățirea performanței cazanului și generarea de căldură, camera de ardere este căptușita cu cărămida de șamot.
      </p>
      <p className={styles.text}>
        Gazele arse ies din coș printr-un colector de fum de forma rotunda, situat în partea din spate a cazanului.
      </p>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th>100 kW</th>
              <th>150 kW</th>
              <th>200 kW</th>
              <th>250 kW</th>
              <th>300 kW</th>
              <th>400 kW</th>
              <th>500 kW</th>
              <th>600 kW</th>
              <th>700 kW</th>
              <th>800 kW</th>
              <th>1000 kW</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Randament, min</td>
              <td>%</td>
              <td colSpan="11">86</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td>m³</td>
              <td>0.5</td>
              <td>0.6</td>
              <td>0.8</td>
              <td>1.0</td>
              <td>1.2</td>
              <td>1.5</td>
              <td>1.9</td>
              <td>2.0</td>
              <td>2.2</td>
              <td>2.3</td>
              <td>2.8</td>
            </tr>
            <tr>
              <td>Greutate cazan, fără apă</td>
              <td>kg</td>
              <td>1200</td>
              <td>1250</td>
              <td>1450</td>
              <td>1800</td>
              <td>2680</td>
              <td>3330</td>
              <td>3900</td>
              <td>3900</td>
              <td>4100</td>
              <td>4500</td>
              <td>4850</td>
            </tr>
            <tr>
              <td>Tirajul necesar a gazelor arse</td>
              <td>Pa</td>
              <td colSpan="11">60-80</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse la evacuare</td>
              <td>°C</td>
              <td colSpan="11">100-180</td>
            </tr>
            <tr>
              <td>Temperatura min recomandată</td>
              <td>°C</td>
              <td colSpan="11">58</td>
            </tr>
            <tr>
              <td>Temperatura max. a apei</td>
              <td>°C</td>
              <td colSpan="11">85</td>
            </tr>
            <tr>
              <td>Presiunea nominală a apei (max. recomandată)</td>
              <td>mPa</td>
              <td colSpan="11">0.3</td>
            </tr>
            <tr>
              <td>Presiunea apei, max</td>
              <td>mPa</td>
              <td colSpan="11">0.45</td>
            </tr>
            <tr>
              <td>Consum curent electric, max</td>
              <td>Wt</td>
              <td>170</td>
              <td>210</td>
              <td>210</td>
              <td>210</td>
              <td>210</td>
              <td>320</td>
              <td>490</td>
              <td>810</td>
              <td>1110</td>
              <td>1110</td>
              <td>1110</td>
            </tr>
            <tr>
              <td>Tensiunea rețelei</td>
              <td>V</td>
              <td colSpan="11">220</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="13">Mărimi burlan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td>cm²</td>
              <td>660</td>
              <td>660</td>
              <td>908</td>
              <td>1194</td>
              <td>1520</td>
              <td>1885</td>
              <td>2290</td>
              <td>2290</td>
              <td>2290</td>
              <td>2290</td>
              <td>2290</td>
            </tr>
            <tr>
              <td>Diametrul intern</td>
              <td>mm</td>
              <td>300</td>
              <td>300</td>
              <td>350</td>
              <td>400</td>
              <td>450</td>
              <td>500</td>
              <td>550</td>
              <td>550</td>
              <td>550</td>
              <td>550</td>
              <td>550</td>
            </tr>
            <tr>
              <td>Înălțime (min permisă)</td>
              <td>m</td>
              <td>7</td>
              <td>9</td>
              <td>9</td>
              <td>10</td>
              <td>12</td>
              <td>13</td>
              <td>14</td>
              <td>15</td>
              <td>18</td>
              <td>21</td>
              <td>27</td>
            </tr>
            <tr>
              <td>Diametrul țevii rețelelor de apă, tur și retur (Du)</td>
              <td>mm</td>
              <td>65</td>
              <td>65</td>
              <td>65</td>
              <td>65</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>100</td>
              <td>100</td>
              <td>100</td>
            </tr>
            <tr>
              <td>Diametrul țevii de sub siguranțele supapei (Du)</td>
              <td>mm</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>2×50</td>
              <td>2×50</td>
              <td>2×50</td>
              <td>2×50</td>
              <td>2×50</td>
              <td>2×65</td>
            </tr>
            <tr>
              <td>Presiunea la care este activată siguranța supapei</td>
              <td>mPa</td>
              <td colSpan="11">0,35</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div >
  );
};

export const BioUniDimensions = () => {
  const data = [
    { param: 'B', unit: 'mm', values: [1360, 1360, 1440, 1440, 1490, 1690, 1690, 1690, 1730, 1730, 1730] },
    { param: 'B1', unit: 'mm', values: [1090, 1090, 1170, 1170, 1330, 1530, 1530, 1530, 1570, 1570, 1570] },
    { param: 'D', unit: 'mm', values: [298, 298, 348, 398, 448, 498, 548, 548, 548, 548, 548] },
    { param: 'H', unit: 'mm', values: [1840, 1840, 1990, 1990, 2300, 2500, 2500, 2500, 2500, 2500, 2500] },
    { param: 'H1', unit: 'mm', values: [1700, 1700, 1850, 1850, 2160, 2360, 2360, 2360, 2360, 2360, 2360] },
    { param: 'H2', unit: 'mm', values: [1383, 1384, 1530, 1530, 1806, 1931, 1956, 1956, 1956, 1956, 1956] },
    { param: 'H3', unit: 'mm', values: [402, 403, 402, 402, 403, 403, 403, 403, 413, 413, 413] },
    { param: 'L', unit: 'mm', values: [1890, 1980, 1980, 2380, 2480, 2500, 2720, 2830, 2920, 3120, 3320] },
    { param: 'L1', unit: 'mm', values: [1045, 1135, 1135, 1535, 1535, 1535, 1735, 1845, 1955, 2155, 2355] },
    { param: 'L2', unit: 'mm', values: [124, 126, 126, 126, 145, 145, 145, 145, 145, 145, 145] },
    { param: 'L3', unit: 'mm', values: [762, 848, 848, 1248, 1220, 970, 1170, 1282, 1370, 1570, 1770] },
  ];

  const headers = ['Parametri', 'U.M.', '100 kW', '150 kW', '200 kW', '250 kW', '300 kW', '400 kW', '500 kW', '600 kW', '700 kW', '800 kW', '1000 kW'];

  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/BioUniSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};


